'use strict';

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var utils = require('./utils');

var Rule = require('./rule');

var Validator = newValidator();

Validator.create = function (options) {
  return newValidator(options);
};

function newValidator(options) {
  var _context;

  options = options || {};
  var validator = {}; // clone methods from Rule to validator

  _forEachInstanceProperty(_context = _Object$keys(Rule.prototype)).call(_context, function (methodName) {
    validator[methodName] = function () {
      var rule = new Rule(options.templates);
      return rule[methodName].apply(rule, arguments);
    };
  });

  validator.isEmpty = utils.isEmpty;
  validator.format = utils.format;
  return validator;
}

module.exports = Validator;